import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
// import * as PIXI from 'pixi.js'
import { setupClicker } from '../controller/ButtonController'

export class FrHintView extends koko.view {
    currentGameView = null;

    textScrollStart = 0;
    textScrollMin = 0;
    textScrollDist = 0;
    scrollerStart = 0;
    scrollerMax = 0;
    draggingText = false;
    draggingScroller = false;

    /* constructor (){
        super();
    } */

    buildView (){
        var vp = app.viewPort;

        this.children = koko.display.buildLayout([
            { type: 'shape', name: 'bg', x: -280, y: 0, width: 1326, height: 1355, fill: 0, alpha: 0.6},

            /*
            { type: 'sprite', id: 'frequency_hintCarrier', name: 'bg2', x: vp.centerX, y: vp.centerY, width: 642, height: 694, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'close_btn', name: 'close_btn', x: 607, y: vp.centerY - 250, width: 75, height: 63, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'hint_title', name: 'title', x: vp.centerX, y: vp.centerY - 200, width: 78, height: 62, anchorX: 0.5, anchorY: 0.5},
            
            { type: 'sprite', id: 'scrolling_box', name: 'box', x: vp.centerX, y: vp.centerY + 140, width: 535, height: 300, anchorX: 0.5, anchorY: 0.5},

            { type: 'shape', name: 'scrollMask', fill: 0, x: vp.centerX - 265, y: vp.centerY + 140 - 146, width: 265 * 2, height: 144 * 2 + 2 },

            { name: 'scroller', id: 'scroller', type: 'sprite', width: 8, height: 98, x: vp.centerX + 255, y: vp.centerY + 140 - 142, anchorX: 0.5, anchorY: 0 },
            { type: 'sprite', id: 'frequencies List', name: 'scrollContent', x: (vp.centerX - 260) + (498 * 0.05), y: vp.centerY + 150 - 142, width: 498 * 0.9, height: 1270 * 0.9, anchorX: 0, anchorY: 0},
            
            { type: 'bmptext', text: 'The table below contains a list of letters by\nfrequency of appearance in standard plain\ntext english. Use this as a guide for what the\nletters could be swapped in the cipher text!', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align:'center', x: vp.centerX, y: vp.centerY - 150, anchorX: 0.5, anchorY: 0},
            */

            { type: 'sprite', id: 'carrier_big', name: 'bg2', x: vp.centerX, y: 678, width: 642, height: 1066, anchorX: 0.5, anchorY: 0.5 },
            { type: 'sprite', id: 'close_btn', name: 'close_btn', x: 600, y: vp.centerY - 450, width: 75, height: 63, anchorX: 0.5, anchorY: 0.5 },
            { type: 'sprite', id: 'hint_title', name: 'title', x: vp.centerX, y: vp.centerY - 400, width: 78, height: 62, anchorX: 0.5, anchorY: 0.5 },

            { type: 'container', name: 'scrollContent', x: vp.centerX, y: 330 },

            { type: 'bmptext', parent: 'scrollContent', text: 'The table below contains a list of the most\nfrequently occurring letters in the English\nlanguage. Use this as a guide for what the\nletters could be swapped for in the\nciphertext!', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align:'left', x: -265, y: 0, anchorX: 0, anchorY: 0},
            { type: 'sprite', id: 'frequencies List', parent: 'scrollContent', name: 'scrollContent_img', x: -260 + (498 * 0.05), y: 180, width: 498 * 0.9, height: 1270 * 0.9, anchorX: 0, anchorY: 0},
            { type: 'bmptext', parent: 'scrollContent', text: 'The letter that appears most frequently\nprobably represents an E, because E is the\nmost common letter in the English language.\nUse the bar chart to find the most frequently\noccurring letter, and enter E in the box\nunderneath it. All of these letters will be\ntransformed into E\'s in blue and you have\nmade the first step in decoding the message!\nThe most common letter may not be E,\nso check it makes sense and be prepared to\nchange it if necessary!\n\nLook for clues in the phrase. The most common\ntwo-letter words in the English language\nare: of, to, in, it, is. The most frequent three-\nletter words are: the, and, for, are, but. Half\nof all English words begin with a, o, s, t or w.\n\nCheck that your guesses reveal real words\nand sentences. (There could be some names in\nthere as the plaintexts are extracts from\nbooks).', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align:'left', x: -265, y: 1353, anchorX: 0, anchorY: 0},

            { type: 'shape', name: 'scrollMask', fill: 0, x: vp.centerX - 295, y: 328, width: 295 * 2, height: 855 },

            { name: 'scroller', id: 'scroller', type: 'sprite', width: 8, height: 98, x: vp.centerX + 295, y: 330, anchorX: 0.5, anchorY: 0 },

            /*
            { type: 'sprite', id: 'wronganswer_carrier', name: 'bg2', x: vp.centerX, y: 400, width: 642, height: 333, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'wronganswer_title', name: 'title', x: vp.centerX, y: 343, width: 98, height: 62, anchorX: 0.5, anchorY: 0.5},
            { type: 'bmptext', text: 'That answer wasn\'t quite right,\nhave another go!', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align:'center', x: vp.centerX, y: 408, anchorX: 0.5, anchorY: 0},
            */
        ], this.container);

        this.resize();

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.close_btn.interactive = true;
        this.children.close_btn.on(event, this.closePop);
        */

        this.children.scrollContent.mask = this.children.scrollMask;
        
        this.draggingText = false;
        this.draggingScroller = false;
    }

    resize () {
        /*
        var vp = app.viewPort;
        let bg = this.children.bg;
        bg.width = vp.width + Math.abs(vp.x) * 4;
        bg.height = vp.height + Math.abs(vp.y) * 4;
        bg.x = vp.centerX - bg.width / 2;
        bg.y = vp.centerY - bg.height / 2;
        */
    }

    initInteraction = () => {
        setupClicker(this.children.close_btn, this.closePop);

        this.textScrollStart = this.children.scrollContent.y;
        let scrollDist = (this.children.scrollContent.height - this.children.scrollMask.height) + 27;
        if (scrollDist < 0) {
            scrollDist = 0;
            this.children.scroller.visible = false;
            this.children.scroller.interactive = false;
        }
        this.textScrollDist = scrollDist;
        this.textScrollMin = this.textScrollStart - scrollDist;

        this.scrollerStart = this.children.scroller.y;
        let scrollerTopBuffer = this.children.scroller.y - this.children.scrollMask.y;
        let scrollArea = this.children.scrollMask.height - scrollerTopBuffer * 2;
        let scrollerHeight = 200 * this.children.scrollMask.height / this.children.scrollContent.height;
        if (scrollerHeight < 20) {
            scrollerHeight = 20;
        }
        this.children.scroller.height = scrollerHeight;
        let scrollerMovement = scrollArea - this.children.scroller.height;
        this.scrollerMax = /*this.scrollerStart + */scrollerMovement;

        this.container.interactive = true;
        this.container.on('mousemove', this.dragSlider);
        this.container.on('pointermove', this.dragSlider);
        this.container.on('touchmove', this.dragSlider);
        this.container.on('mouseup', this.stopDraggingSlider);
        this.container.on('pointerup', this.stopDraggingSlider);
        this.container.on('touchend', this.stopDraggingSlider);

        document.onmouseleave = this.stopDraggingSlider;
        document.onpointerleave = this.stopDraggingSlider;
        document.onmouseup = this.stopDraggingSlider;
        document.onpointerup = this.stopDraggingSlider;

        if (this.children.scroller.visible) {
            this.children.scrollMask.on('mousedown', this.startDraggingText);
            this.children.scrollMask.on('pointerdown', this.startDraggingText);
            this.children.scrollMask.on('touchstart', this.startDraggingText);
            this.children.scrollMask.interactive = true;
        }

        if (this.children.scroller.visible) {
            this.children.scroller.on('mousedown', this.startDraggingScroller);
            this.children.scroller.on('pointerdown', this.startDraggingScroller);
            this.children.scroller.on('touchstart', this.startDraggingScroller);
            this.children.scroller.interactive = true;
        }
    }

    transitionIn = (currentGameView = null) => {
        this.currentGameView = currentGameView;
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35, onComplete: this.initInteraction});

        // setTimeout(this.transitionOut, 2000);

        au.playRandom('pop', 1, 10);
    }

    transitionOut = () => {
        if (this.currentGameView && this.currentGameView.popClosed) {
            this.currentGameView.popClosed();
        }

        gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
    }

    transitionOutDone = () => {
        // gsap.killAll();
        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
    }

    closePop = (e) => {
        au.play('button', 1, false);
        if (this.currentGameView && this.currentGameView.popClosed) {
            this.currentGameView.popClosed();
        }
        this.transitionOut();
    }

    startDraggingText = (e) => {
            // console.log('start dragging text');
            this.draggingText = true;
            this.startMouseY = this.container.toLocal(e.data.global).y;
            this.startTextY = this.children.scrollContent.y;
            // this.closeKeyboard();
    }

    startDraggingScroller = (e) => {
            this.draggingScroller = true;
            this.startMouseY = this.container.toLocal(e.data.global).y;
            this.startScrollerY = this.children.scroller.y;
            // this.closeKeyboard();
    }

    dragSlider = (e) => {
        if (this.draggingScroller) {
            let thisPoint = this.container.toLocal(e.data.global);
            let moveDistance = thisPoint.y - this.startMouseY;
            let newY = this.startScrollerY + moveDistance;
            if (newY > this.scrollerStart + this.scrollerMax) {
                newY = this.scrollerStart + this.scrollerMax;
            }
            if (newY < this.scrollerStart) {
                newY = this.scrollerStart;
            }
            this.children.scroller.y = newY;
            let movePerc = Math.abs(this.children.scroller.y - this.scrollerStart) / this.scrollerMax;
            this.children.scrollContent.y = this.textScrollStart - movePerc * this.textScrollDist;
        } else
        if (this.draggingText) {
            let thisPoint = this.container.toLocal(e.data.global);
            let moveDistance = thisPoint.y - this.startMouseY;
            let newY = this.startTextY + moveDistance;
            if (newY > this.textScrollStart) {
                newY = this.textScrollStart;
            }
            if (newY < this.textScrollMin) {
                newY = this.textScrollMin;
            }
            this.children.scrollContent.y = newY;
            let movePerc = Math.abs(this.children.scrollContent.y - this.textScrollStart) / Math.abs(this.textScrollStart - this.textScrollMin);
            this.children.scroller.y = this.scrollerStart + movePerc * this.scrollerMax;
        }
    }

    stopDraggingSlider = (e) => {
        this.draggingText = false;
        this.draggingScroller = false;
    }
}